export default __webpack_public_path__ + "static/media/large-table.340ad19c.svg";